import { useEffect } from "react";
import { Hub } from "aws-amplify";
import type { HubCapsule } from "@aws-amplify/core";
import { recordSsoFailure } from "./ssoSession";

/** Amplify's auth Hub channel. */
export const AUTH_HUB_CHANNEL = "auth";
/** Emitted when the Cognito hosted UI / IdP round trip fails. */
export const HOSTED_UI_FAILURE_EVENT = "cognitoHostedUI_failure";

/**
 * Records an IdP sign-in failure so AuthPage stops auto-redirecting to
 * /saml/* — otherwise a broken IdP produces an endless app → IdP → app loop.
 *
 * `cognitoHostedUI_failure` only: Amplify dispatches it alongside
 * `signIn_failure` for every hosted-UI failure, and `signIn_failure` also fires
 * for a wrong password (reachable in an enforced org via ?sso=off), which would
 * record a bogus SSO failure.
 */
export const useSsoFailureListener = (): void => {
  useEffect(() => {
    const unsubscribe = Hub.listen(
      AUTH_HUB_CHANNEL,
      ({ payload }: HubCapsule) => {
        if (payload.event === HOSTED_UI_FAILURE_EVENT) {
          recordSsoFailure();
        }
      }
    );
    // Amplify 5's Hub.listen returns its own cancel function.
    return unsubscribe;
  }, []);
};
